import styled from '@emotion/styled';
import { Modal as ModalBase } from '@ui-components/neo.tax';

export const Modal = styled(ModalBase)({
  maxWidth: '515px',
  width: '100%',
});
